import React from 'react';
import { MapPin, Phone } from 'lucide-react';

const Hero = () => {
  return (
    <section className="min-h-screen md:min-h-0 bg-sage-50 pt-28 pb-8 md:pt-32 md:pb-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-5 md:space-y-8">
            <div className="w-10 md:w-16 h-0.5 md:h-1 bg-sage-600"></div>
            
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-serif text-gray-900 leading-tight">
              Where Style Meets{' '}
              <span className="italic text-sage-600">Artistry.</span>
            </h1>

            <p className="text-sm md:text-lg text-gray-600 font-light leading-relaxed max-w-lg">
              Discover personalised hair care in the heart of Albany. At Kove, we specialise in colour transformations and blonde artistry, delivering 1-on-1 service tailored exclusively to you.
            </p>

            {/* Mobile: Two Minimalist CTAs */}
            <div className="md:hidden pt-2 space-y-3">
              <div>
                <a
                  href="sms:0475409162"
                  className="inline-block text-sage-700 font-normal text-sm border-b-2 border-sage-600 pb-1 hover:text-sage-800 transition-colors duration-300"
                >
                  Book Appointment →
                </a>
              </div>
              <div>
                <a
                  href="#services"
                  className="inline-block text-gray-600 font-light text-sm border-b border-gray-400 pb-1 hover:text-gray-800 transition-colors duration-300"
                >
                  View Services
                </a>
              </div>
            </div>

            {/* Desktop: Full Buttons */}
            <div className="hidden md:flex flex-col sm:flex-row gap-4">
              <a
                href="sms:0475409162"
                className="inline-flex items-center justify-center bg-sage-600 text-white px-8 py-4 rounded-full hover:bg-sage-700 transition-all duration-300 font-normal tracking-wide shadow-lg"
              >
                BOOK APPOINTMENT
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center border-2 border-sage-600 text-sage-700 px-8 py-4 rounded-full hover:bg-sage-50 transition-all duration-300 font-normal tracking-wide"
              >
                VIEW SERVICES
              </a>
            </div>

            <div className="flex flex-col gap-2 pt-1 md:pt-0 text-xs md:text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 md:w-4 md:h-4 text-sage-600 flex-shrink-0" />
                <span>Middleton Loop, Albany</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-3.5 h-3.5 md:w-4 md:h-4 text-sage-600 flex-shrink-0" />
                <span>0475 409 162</span>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative mt-6 md:mt-0">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-xl md:shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/egms5m2h_IMG_8494.jpeg"
                alt="Tess and Hayley, owners of Kove"
                className="w-full h-auto md:aspect-[4/3.4] md:object-cover"
              />
              <div className="absolute bottom-3 md:bottom-6 left-3 md:left-6 right-3 md:right-6 bg-white/90 backdrop-blur-sm p-2.5 md:p-4 rounded-lg">
                <p className="text-xs md:text-sm text-gray-700 font-light italic">
                  Tess &amp; Hayley — Kove the Studio
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;